export const ICPSubDesignationValues = {
  Owner: ['Owner'],
  Partner: ['Partner', 'Managing Partner'],
  Founder: ['Founder'],
  'C Suite': ['Chairman', 'Managing Director', 'Executive Director', 'C Suite'],
  VP: [
    'Associate Vice President',
    'Executive Vice President',
    'Senior Vice President',
    'Vice President',
    'General Manager',
  ],
  Head: ['Head', 'Associate Head'],
  Director: ['Controller', 'Associate Director', 'Senior Director', 'Director'],
  Manager: ['Senior Manager', 'Associate Manager', 'Manager', 'Team Lead', 'Chief Manager'],
  Senior: ['Senior'],
  Entry: ['Entry'],
  Intern: ['Intern'],
  President: ['President'],
};

export const SeniorityDesignation = [
  {
    id: 'C Suite',
    label: 'C Suite',
  },
  {
    id: 'Founder',
    label: 'Founder',
  },
  {
    id: 'President',
    label: 'President',
  },
  {
    id: 'VP',
    label: 'VP',
  },
  {
    id: 'Head',
    label: 'Head',
  },
  {
    id: 'Director',
    label: 'Director',
  },
  {
    id: 'Partner',
    label: 'Partner',
  },
  {
    id: 'Manager',
    label: 'Manager',
  },
  {
    id: 'Senior',
    label: 'Senior',
  },
  {
    id: 'Entry',
    label: 'Entry',
  },
  {
    id: 'Owner',
    label: 'Owner',
  },
  {
    id: 'Intern',
    label: 'Intern',
  },
  {
    id: 'Others',
    label: 'Others',
  },
];
